<template>
    <div class="profile">
        <ProfileImage :is-pilulka-employee="user.isPilulkaEmployee" />
        <UserInfo :user="user" />
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import ProfileImage from '~/components/objects/Discussion/Profile/ProfileImage.vue'
import UserInfo from '~/components/objects/Discussion/Profile/UserInfo.vue'
import User from '~/models/Discussion/User'

export default {
    components: {
        ProfileImage,
        UserInfo,
    },

    props: {
        user: {
            type: Object as PropType<User>,
            default: null,
        },
    },
}
</script>

<style lang="scss" scoped>
.profile {
    display: flex;
    width: 100%;
    align-items: center;
    height: 100%;
    flex-direction: row;
    padding: 0;

    @include screen-md {
        height: 100%;
        justify-content: center;
        flex-direction: column;
        padding: 2rem;
    }
}
</style>
